import React from 'react';
export var TextContext = /*#__PURE__*/React.createContext({});